import { RemoteGetDirectorNotifications } from 'data/usecases/notifications';
import { makeApiUrlDirectorNotifications } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetDirectorNotifications =
  (): RemoteGetDirectorNotifications => {
    return new RemoteGetDirectorNotifications(
      makeApiUrlDirectorNotifications(),
      makeAxiosHttpClient(),
    );
  };
